import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import TaskLabelChips from '../TaskLabelChips';
import LabelColorPicker from './LabelColorPicker';
import { DEFAULT_LABEL_COLOR } from '../../extensions/bundled/task-manager/boardLabels';
import './BoardLabelEditor.css';

/**
 * The new-label row under the palette (card 5.3): ONE split input — the colour
 * dropdown and the name share a border — then a live preview pill and Add.
 *
 * `onAdd({ name, color })` returns true when the label was added; on false (a
 * duplicate name, compared case-insensitively by addLabel) the text stays so
 * you can see what you typed, and the row says why.
 */
export default function BoardLabelAddRow({ onAdd }) {
  const [draft, setDraft] = useState('');
  const [color, setColor] = useState(DEFAULT_LABEL_COLOR);
  const [duplicate, setDuplicate] = useState(false);

  const add = () => {
    const name = draft.trim();
    if (!name) return;
    if (onAdd({ name, color })) {
      setDraft('');
      setColor(DEFAULT_LABEL_COLOR);
      setDuplicate(false);
    } else {
      setDuplicate(true);
    }
  };

  return (
    <div className="board-label-add">
      <div className="board-label-add-row">
        <div className="board-label-split">
          <LabelColorPicker value={color} onChange={setColor} variant="split" aria-label="New label colour" />
          <input
            type="text"
            className="board-label-split-input"
            placeholder="New label…"
            value={draft}
            aria-label="New label name"
            aria-invalid={duplicate || undefined}
            onChange={(e) => {
              setDraft(e.target.value);
              setDuplicate(false);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                // The row sits inside the board form; Enter adds a label, it
                // must not submit and close the whole modal.
                e.preventDefault();
                add();
              }
            }}
          />
        </div>
        {draft.trim() && <TaskLabelChips labels={[{ id: 'new', name: draft.trim(), color }]} className="board-label-preview" />}
        <button type="button" className="board-label-add-btn" aria-label="Add label" disabled={!draft.trim()} onClick={add}>
          <Plus size={12} aria-hidden />
          Add
        </button>
      </div>
      {duplicate && (
        <span className="board-label-add-error" role="status">
          A label called “{draft.trim()}” already exists.
        </span>
      )}
    </div>
  );
}
